import { takeLatest, takeEvery, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/articuloReducer/actions'
import * as catalogoActions from '../../reducers/catalogoReducer/actions'
import * as layoutActions from '../../reducers/layoutReducer/actions'
import * as articuloActions from '../../reducers/articuloReducer/actions'
import * as Notifications from '../../components/Common/notification'

function* genGetTipotalle(){
    try {

        // llamo a la acción que trae los rubros
        let rubros = yield calls.getTipotalle()
        yield put(reducerActions.setTipotalle(rubros))
        
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}

function* genSaveArticulo(e){
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Guardando artículo' }))

        // llamo a la acción que guarda el catálogo
        let idArticulo = yield calls.saveArticulo(e.payload)

        //let idTemporalEdition= Math.floor(1000 + Math.random() * 9000)    

        //let articulo = yield calls.getArticuloCompleto({ id: idArticulo, idTemporalEdition:idTemporalEdition })
       
        //Agregar ese articulo al catalogo
        //yield put(catalogoActions.addArticuloCatalogo(articulo))
        
        /*let articuloNuevo = yield calls.saveArticulo(e.payload)
        
        if(e.payload.IdArticulo === 0){
            yield put(catalogoActions.agregarArticuloACatalogoCompleto(articuloNuevo))
        }*/
        
        
        // actualizo el array de imágenes del artículo en el reductor de catálogo (fuerza la recarga de la imagen)
        yield put(catalogoActions.removeImagenesArticulo(e.payload.IdArticulo))

        
        // llamo a la functión de callback
        e.payload.afterSaveArticulo()
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        
        yield put(layoutActions.setLoading({ show: false }))
        // oculto el loader
        
        
    }
}

function* genSaveArticuloGenerico(e){
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Guardando artículo' }))

        // llamo a la acción que guarda el catálogo
        let idArticulo = yield calls.saveArticuloGenerico(e.payload)

        // actualizo el array de imágenes del artículo en el reductor de catálogo (fuerza la recarga de la imagen)
        yield put(catalogoActions.removeImagenesArticulo(e.payload.IdArticulo))

        
        // llamo a la functión de callback
        e.payload.afterSaveArticulo()
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        yield put(layoutActions.setLoading({ show: false }))
        // oculto el loader
        
        
    }
}


function* genGetArticuloImagenes(e){
    try {
        // llamo a la acción que trae las imágenes de un artículo
        let imagenesArticulo = yield calls.getArticuloImagenes(e.payload)

        // actualizo el array de imágenes de catálogo
        let item = {
            idArticulo: e.payload.idArticulo,
            imagenes: imagenesArticulo
        }
    
        yield put(reducerActions.sagaSetImagenesListadoArticulos(item))
    }
    catch (e) 
    {
    }
}


function* genBorrarArticulo(e){
    try {
        let payload = {
            ...e.payload
        }
        payload.callback = undefined
        
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Borrando artículo' }))

        // llamo a la acción que borra el Arti
        let deleted = yield calls.borrarArticulo(payload)
        yield put(reducerActions.setArticuloBorrado(deleted))
        
        //Pongo como undefined el articulo borrado en el catalogo completo para que no se renderice
        yield put(catalogoActions.borrarArticuloDeCatalogoCompleto(e.payload.idArticulo))

        e.payload.callback()
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}




function* genBorrarArticuloFromCatalogo(e){
    try {
        let payload = {
            ...e.payload
        }
        payload.callback = undefined
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Borrando entrada catálogo' }))

        // llamo a la acción que borra el Arti
        let deleted = yield calls.borrarArticuloFromCatalogo(payload)
        yield put(reducerActions.setArticuloEntradaBorrado(e.payload.idArticulo))
        
        //Pongo como undefined el articulo borrado en el catalogo completo para que no se renderice
       // yield put(catalogoActions.borrarArticuloDeCatalogoCompleto(e.payload.idArticulo))
        //yield put(reducerActions.setArticuloEntradaBorrado(e.payload.idArticulo))

        e.payload.callback()
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}






function* genAgregarArticuloToCatalogo(e){
    try {
        let payload = {
            ...e.payload
        }
        payload.callback = undefined
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Agregando entrada catálogo' }))

        // llamo a la acción que borra el Arti
        let deleted = yield calls.agregarArticuloToCatalogo(payload)
        yield put(reducerActions.setArticuloEntradaBorrado(e.payload.idArticulo))
        
        //Pongo como undefined el articulo borrado en el catalogo completo para que no se renderice
       // yield put(catalogoActions.borrarArticuloDeCatalogoCompleto(e.payload.idArticulo))
        //yield put(reducerActions.setArticuloEntradaBorrado(e.payload.idArticulo))

        e.payload.callback()
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        Notifications.showSuccess("Entrada agregada con éxito")
        yield put(layoutActions.setLoading({ show: false }))
    }
}



function* genSaveImagenArticulo(e){
    try {
        // llamo a la acción que guarda el catálogo
        yield calls.saveImagenArticulo(e.payload)

        yield put(articuloActions.incrementarContadorTemporal())
    }
    catch (f) 
    {
        // muestro el mensaje de error
        Notifications.showError(f.error)
        yield put(articuloActions.incrementarContadorTemporal())

        if(e.payload.callbackDelete){
            e.payload.callbackDelete()
        }
    }
}
///
function* genSaveImagenArticuloRecorte(e){
    try {

        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Generando recorte' }))

        // llamo a la acción que guarda el catálogo
        yield calls.saveImagenArticuloRecorte(e.payload)

        if(e.payload.callback){
            e.payload.callback()
        }
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError("No se guardó el recorte. Intente nuevamente.")
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genSaveImagenArticuloTallecolor(e){
    try {

        // llamo a la acción que guarda el catálogo
        yield calls.saveImagenArticuloTallecolor(e.payload)
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
}

function* genSaveImagenTalleColorRecorte(e){
    try {
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Generando recorte' }))
        
        // llamo a la acción que guarda el catálogo
        yield calls.saveImagenTalleColorRecorte(e.payload)
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genGetListadoArticulo(e){ // Probar ahora lo de la busqueda normal.
    try {
      
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Recuperando artículos' }))

        // llamo a la acción que trae el catálogo
        let articulo = yield calls.getListadoArticulos(e.payload)

        
        if (e.payload.Callback !== undefined){
            e.payload.Callback()
        }
        
        yield put(reducerActions.setListadoArticulos(articulo))
        
        
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}



function* genGetListadoArticulosEnCatalogo(e){ 
    try {
      
        // muestro el loader
        if (e.payload.page==1)
            yield put(layoutActions.setLoading({ show: true, message: 'Recuperando entradas de catálogo' }))

        // llamo a la acción que trae las entradas de catálogo
        let articulo = yield calls.getListadoEntradas(e.payload)

        
        if (e.payload.Callback !== undefined){
            e.payload.Callback()
        }
        
        yield put(reducerActions.setListadoEntradas(articulo))
        
        
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}




function* genGetListadoArticulosAusentesEnCatalogo(e){ 
    try {
        // muestro el loader
        if (e.payload.page==1)
            yield put(layoutActions.setLoading({ show: true, message: 'Recuperando productos disponibles' }))

        // llamo a la acción que trae las entradas de catálogo
        let articulo = yield calls.getListadoArticulosAusentesEnCatalogo(e.payload)

        
        if (e.payload.Callback !== undefined){
            e.payload.Callback()
        }
        
        yield put(reducerActions.setListadoEntradas(articulo))
        
        
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}



function* genGetArticuloCompleto(e){
    try {
      
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Recuperando artículo' }))

        // llamo a la acción que trae el catálogo
        let articulo = yield calls.getArticuloCompleto(e.payload)
        yield put(reducerActions.setArticuloCompleto(articulo))        
    }
    catch (e) 
    {
        // muestro el mensaje de error
        Notifications.showError(e.error)
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genGetArticuloImagen(e){
    try {
        
        // si se está buscando la imagen original para editarla, muestro el loader
        if(e.payload.recorte === false)
        {
            yield put(layoutActions.setLoading({ show: true, message: 'Recuperando imagen' }))
        }

        // llamo a la acción que trae la imagen del artículo
        let imagen = yield calls.getArticuloImagen(e.payload)

        // asigno la imagen del artículo
        let articuloImagen = {
            idArticuloImagen: e.payload.idArticuloImagen,
            imagen: imagen
        }

        // asigno el recorte o la imagen original del artículo
        if(e.payload.recorte)
            yield put(reducerActions.setArticuloImagen(articuloImagen))
        else
            yield put(reducerActions.setArticuloImagenOriginal(articuloImagen))
    }
    catch (e) 
    {
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genGetStockImagen(e){
    try {
        
        // si se está buscando la imagen original para editarla, muestro el loader
        if(e.payload.recorte === false)
        {
            yield put(layoutActions.setLoading({ show: true, message: 'Recuperando imagen' }))
        }
        // llamo a la acción que trae la imagen del stock
        let imagen = yield calls.getStockImagen(e.payload)

        // asigno la imagen del stock
        let stockImagen = {
            idTalleColor: e.payload.idTalleColor,
            imagen: imagen
        }

        // asigno el recorte o la imagen original del artículo
        if(e.payload.recorte)
            yield put(reducerActions.setStockImagen(stockImagen))
        // else
        //     yield put(reducerActions.setArticuloImagenOriginal(stockImagen))
    }
    catch (e) 
    {
    }
    finally 
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* defaultSaga() {
    yield all([      
      takeLatest(reducerActions.SAGA_GET_TIPOTALLE, genGetTipotalle),
      takeLatest(reducerActions.SAGA_GET_ARTICULO_COMPLETO, genGetArticuloCompleto),
      takeLatest(reducerActions.SAGA_GET_LISTADO_ARTICULO, genGetListadoArticulo),
      takeLatest(reducerActions.SAGA_GET_LISTADO_ENTRADA, genGetListadoArticulosEnCatalogo),
      takeLatest(reducerActions.SAGA_GET_LISTADO_ARTICULOS_AUSENTES_EN_CATALOGO,genGetListadoArticulosAusentesEnCatalogo),
      takeLatest(reducerActions.SAGA_SAVE_ARTICULO, genSaveArticulo),
      takeLatest(reducerActions.SAGA_SAVE_ARTICULO_GENERICO, genSaveArticuloGenerico),
      takeLatest(reducerActions.SAGA_SAVE_ARTICULO_BORRAR,genBorrarArticulo ),
      takeLatest(reducerActions.SAGA_SAVE_ARTICULO_ENTRADA_BORRAR, genBorrarArticuloFromCatalogo),
      takeLatest(reducerActions.SAGA_SAVE_ARTICULO_ENTRADA_AGREGAR,genAgregarArticuloToCatalogo),
      takeEvery(reducerActions.SAGA_SAVE_ARTICULO_IMAGEN, genSaveImagenArticulo),
      takeLatest(reducerActions.SAGA_SAVE_ARTICULO_IMAGEN_TALLECOLOR, genSaveImagenArticuloTallecolor),

      takeLatest(reducerActions.SAGA_SAVE_ARTICULO_IMAGEN_RECORTE, genSaveImagenArticuloRecorte),
      takeLatest(reducerActions.SAGA_SAVE_ARTICULO_IMAGEN_TALLECOLOR_RECORTE, genSaveImagenTalleColorRecorte),
      takeEvery(reducerActions.SAGA_GET_IMAGEN_ARTICULO, genGetArticuloImagen),

      takeEvery(reducerActions.SAGA_GET_IMAGEN_STOCK, genGetStockImagen), 
      takeEvery(reducerActions.SAGA_GET_IMAGEN_ARTICULO_LISTADO, genGetArticuloImagenes),
    ])
  }
  
  export const sagas = [
    defaultSaga
  ]